export default "__VITE_ASSET__B2K_pvat__"